var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_916_1725)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9229 13.9225C13.5975 14.248 13.0698 14.248 12.7444 13.9225L10.0003 11.1785L7.25625 13.9225C6.93081 14.248 6.40317 14.248 6.07774 13.9225C5.7523 13.5971 5.7523 13.0695 6.07774 12.744L9.41107 9.4107C9.73651 9.08527 10.2641 9.08527 10.5896 9.4107L13.9229 12.744C14.2484 13.0695 14.2484 13.5971 13.9229 13.9225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0007 18.3334C9.54041 18.3334 9.16732 17.9603 9.16732 17.5L9.16732 10C9.16732 9.5398 9.54041 9.16671 10.0007 9.16671C10.4609 9.16671 10.834 9.5398 10.834 10L10.834 17.5C10.834 17.9603 10.4609 18.3334 10.0007 18.3334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22265 1.66186C8.35638 1.62109 9.4846 1.83804 10.5224 2.29639C11.5601 2.75474 12.4804 3.44254 13.2138 4.30801C13.8059 5.00664 14.2638 5.80635 14.5667 6.66672L14.999 6.66672C16.0616 6.66603 17.0975 7.00388 17.9551 7.63128C18.8129 8.25881 19.4484 9.14336 19.7694 10.1565C20.0904 11.1697 20.0802 12.2589 19.7403 13.2659C19.4004 14.2729 18.7484 15.1454 17.879 15.7567C17.5025 16.0215 16.9827 15.9309 16.718 15.5544C16.4533 15.1779 16.5438 14.6581 16.9203 14.3934C17.4999 13.9858 17.9346 13.4042 18.1612 12.7328C18.3878 12.0615 18.3946 11.3354 18.1806 10.6599C17.9666 9.98448 17.5429 9.39478 16.971 8.97643C16.3992 8.55808 15.7089 8.33284 15.0003 8.33339H13.9497C13.5692 8.33339 13.237 8.0757 13.1425 7.70718C12.9232 6.8525 12.5128 6.05871 11.9424 5.38557C11.3719 4.71242 10.6561 4.17747 9.84898 3.82098C9.04184 3.46448 8.16434 3.29574 7.28255 3.32745C6.40075 3.35916 5.53764 3.5905 4.75819 4.00405C3.97874 4.4176 3.30326 5.00259 2.78261 5.71497C2.26196 6.42735 1.9097 7.24856 1.75235 8.11678C1.59501 8.98501 1.63667 9.87761 1.87421 10.7274C2.11175 11.5772 2.53898 12.362 3.12373 13.0228C3.42873 13.3675 3.39658 13.8941 3.05191 14.1991C2.70725 14.5041 2.1806 14.472 1.87559 14.1273C1.12377 13.2777 0.574483 12.2687 0.269074 11.1761C-0.0363347 10.0835 -0.0899036 8.93586 0.1124 7.81958C0.314704 6.70329 0.767609 5.64745 1.43702 4.73153C2.10643 3.81561 2.9749 3.06348 3.97705 2.53177C4.9792 2.00007 6.08891 1.70263 7.22265 1.66186Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_916_1725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/UploadCloud.84e859b702cdc503b036fcbaac01b852.svg";
export { ForwardRef as ReactComponent };